import MesesCompetenciasService from '@/services/mesesCompetenciasService';
import RecadastramentoService from '@/services/recadastramentoService';
import ErrorHelper from '@/helpers/ErrorHelper';

const validaRecadastramento = async (next, app) => {
  const recadastramentos = await obtemMesCompetenciaRecad(app);
  
  const existeRecadastramento = !!recadastramentos.length;

  if (!existeRecadastramento) {
    return false;
  }

  const hoje = new Date();
  
  const algumPeriodoAtivo = recadastramentos.some(recad => {
    if (!recad.periodos || !recad.periodos.length) return false;
    
    return recad.periodos.some(periodo => {
      const dataInicio = new Date(periodo.dataInicioLancamento + 'T00:00:00');
      const dataFim = new Date(periodo.dataFimLancamento + 'T23:59:59');
      return hoje >= dataInicio && hoje <= dataFim;
    });
  });

  return algumPeriodoAtivo;
};

const validaRecadastramentoPorId = async (recadId, app) => {
     const recad = await RecadastramentoService.obtemPorId(recadId);
     const mesCompetencia = await MesesCompetenciasService.obtemPorId(recad.competencia.id);
     
     const hoje = new Date();
     const algumPeriodoAtivo = mesCompetencia.periodos && mesCompetencia.periodos.length ? 
      mesCompetencia.periodos.some(periodo => {
          const dataInicio = new Date(periodo.dataInicioLancamento + 'T00:00:00');
          const dataFim = new Date(periodo.dataFimLancamento + 'T23:59:59');
          return hoje >= dataInicio && hoje <= dataFim;
      }) : false; 
      
     return algumPeriodoAtivo;
}

const obtemMesCompetenciaRecad = async app => {
  try {
      const recads = await MesesCompetenciasService.listaPorEvento('ATUALIZACAO_CADASTRAL');
      return recads.content || [];
  } catch (error) {
    const mensagem = ErrorHelper.trataMensagem(error);
    if (app && app.$root && app.$root.$refs && app.$root.$refs.toastr) {
      app.$root.$refs.toastr.e(mensagem, 'Atenção');
    }
    return [];
  }
};

// Exporta ambas
export {
  validaRecadastramento,
  validaRecadastramentoPorId
};

export default validaRecadastramento;



// WEBPACK FOOTER //
// ./src/router/validaRecadastramento.js